import { Component } from '@angular/core';
import { KENDO_SKELETON } from '@progress/kendo-angular-indicators';
import { KENDO_GRIDLAYOUT } from '@progress/kendo-angular-layout';
import { LogoSharedComponent } from '@unity/shared/presentation/logo-shared/logo-shared.component';
import { PanelContextSharedComponent } from '@unity/shared/presentation/panel-context-shared/panel-context-shared.component';

@Component({
  selector: 'unity-banner-context-shared',
  standalone: true,
  imports: [KENDO_GRIDLAYOUT, KENDO_SKELETON, PanelContextSharedComponent, LogoSharedComponent],
  templateUrl: './banner-context-shared.component.html',
  styleUrl: './banner-context-shared.component.scss',
})
export class BannerContextSharedComponent {}
